<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - 3. {{ $t('solarPanels') }}</h3>
      </div>

      <div class="two-column-grid" v-for="i in range(3, 4)" :key="i">
        <div>{{ $t('solarPanelAttachments_C') }} {{ $t('image') }} {{ i }}</div>
        <div>
          <img
            v-if="project.enpalReport.solarPanelAttachments_C[i - 1]"
            :src="project.enpalReport.solarPanelAttachments_C[i - 1].path"
            alt=""
          />
        </div>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('solarPanelC1State') }}</div>
        <div>
          {{ $t(project.enpalReport.solarPanelC1State) }}
        </div>
        <div>{{ $t('solarPanelDState') }}</div>
        <div>
          {{ $t(project.enpalReport.solarPanelDState) }}
        </div>
      </div>
      <div class="two-column-grid" v-for="i in range(1, 2)" :key="i">
        <div>{{ $t('solarPanelAttachments_E1') }} {{ $t('image') }} {{ i }}</div>
        <div>
          <img
            v-if="project.enpalReport.solarPanelAttachments_E1[i - 1]"
            :src="project.enpalReport.solarPanelAttachments_E1[i - 1].path"
            alt=""
          />
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
